import React from "react";
import { createRoot } from "react-dom/client";
import App from "./App";
import { unregister } from "./registerServiceWorker";

createRoot(document.getElementById("root")).render(<App />);

// Prevent stale caching during development (and keep deploys predictable).
unregister();
